<template>
      <v-snackbar
        v-model="data.status"
        :timeout="data.timeout"
       
   
      >
        {{ data.text }}
  
        <template v-slot:actions>
          <v-btn
            color="blue"
            variant="text"
            icon="$close"
            density="compact"
            @click="snackbar.snackbar_reset()"
          >
           
          </v-btn>
        </template>
      </v-snackbar>
  
  </template>

<script setup>

import { useSnackbarStore } from '../../stores/snackbarStore';



const data = useSnackbarStore().data

const snackbar = useSnackbarStore()

</script>